import { useState } from 'react'

import { Button } from '@/components/ui/button'
import type { PolicyChangeRequest } from '@/models/policyChange'
import { ClaimStepShell } from '../Claims/ClaimStepShell'
import { ChangeDates } from './ChangeDates'

interface StepDatesProps {
  orgId: string
  request: PolicyChangeRequest
  onBack: () => void
  onNext: () => void
}

/** The form's third step: the date each change starts. */
export function StepDates({ orgId, request, onBack, onNext }: StepDatesProps) {
  const [pendingSaves, setPendingSaves] = useState(0)
  const saving = pendingSaves > 0

  return (
    <ClaimStepShell
      step={3}
      stepCount={4}
      title="Effective dates"
      subtitle="The day each change starts on your policies. We suggest one from the dates you gave us, and your insurance providers price the change from it."
    >
      <ChangeDates orgId={orgId} request={request} setPendingSaves={setPendingSaves} />
      <div className="flex justify-between">
        <Button type="button" variant="outline" disabled={saving} onClick={onBack}>
          ← Back
        </Button>
        <Button type="button" onClick={onNext} loading={saving ? 'Saving…' : undefined}>
          Next →
        </Button>
      </div>
    </ClaimStepShell>
  )
}
